// ============================================================
// HEZOKIDS.BG — Flipbook Lightbox
// Файл: assets/hezokids-custom.js
// Зарежда се само на: /products/knijka-s-roditeli
// ============================================================

document.addEventListener('DOMContentLoaded', function () {

  // Само на десктоп — на мобилно не правим нищо
  if (window.innerWidth < 768) return;

  const iframe = document.querySelector('iframe[src*="li-lookthru"]');
  if (!iframe) return;

  const iframeSrc = iframe.src;
  const wrapper = iframe.parentElement;

  // --- Бутон "Разгледай на цял екран" ---
  const btn = document.createElement('button');
  btn.id = 'hezokids-flipbook-btn';
  btn.innerHTML = `
    <span class="material-icons-two-tone">fullscreen</span>
    Разгледай на цял екран
  `;
  wrapper.parentElement.insertBefore(btn, wrapper.nextSibling);

  // --- Overlay / Lightbox ---
  const overlay = document.createElement('div');
  overlay.id = 'hezokids-flipbook-overlay';
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('role', 'dialog');
  overlay.innerHTML = `
    <button id="hezokids-flipbook-close" aria-label="Затвори">
      <span class="material-icons-two-tone">close</span>
    </button>
    <iframe
      src="${iframeSrc}"
      title="Разгледай книжката"
      allowfullscreen
    ></iframe>
  `;
  document.body.appendChild(overlay);

  // --- Отвори ---
  btn.addEventListener('click', () => {
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  // --- Затвори ---
  const closeBtn = overlay.querySelector('#hezokids-flipbook-close');

  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  function close() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

});